import { GET_VOUCHER_BOOKING, GET_VOUCHER_BOOKING_SUCCESS, GET_VOUCHER_BOOKING_ERROR, GET_VOUCHER_BOOKING_EMPTY } from '../../../actionType.js';

const initialState = {
  data: null,
  message: null,
  loading: false,
  success: false,
  error: false,
};

const GetVoucherBooking = (state = initialState, action) => {
  switch (action.type) {
    case GET_VOUCHER_BOOKING:
      state = {
        ...state,
        // data: null,
        loading: true,
        success: false,
        error: false,
        message: null,
      };
      break;

    case GET_VOUCHER_BOOKING_SUCCESS:
      state = {
        ...state,
        data: action.payload,
        loading: false,
        success: true,
        error: false,
        message: null,
      };
      break;

    case GET_VOUCHER_BOOKING_ERROR:
      state = {
        ...state,
        data: null,
        loading: false,
        success: false,
        error: true,
        message: action.payload,
      };
      break;

    case GET_VOUCHER_BOOKING_EMPTY:
      state = {
        ...initialState,
      };
      break;

    default:
      state = { ...state };
      break;
  }
  return state;
};

export default GetVoucherBooking;
